import { useState } from 'react';
import betClient from '../../api/betClient';

function renderMarkdown(text) {
  const parts = text.split(/(\*\*[^*]+\*\*|\*[^*]+\*)/g);
  return parts.map((part, j) => {
    if (part.startsWith('**') && part.endsWith('**')) {
      return <strong key={j} className="font-semibold text-[#111827] dark:text-[#e2e8f0]">{part.slice(2, -2)}</strong>;
    }
    if (part.startsWith('*') && part.endsWith('*') && part.length > 2) {
      return <em key={j}>{part.slice(1, -1)}</em>;
    }
    return part;
  });
}

export default function AiInsightCard({ analysisType, params }) {
  const [insight, setInsight] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  function fetchInsight(force = false) {
    setLoading(true); setError(null);
    const qs = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => { if (v != null) qs.set(k, v); });
    if (force) qs.set('force', 'true');
    betClient.get(`/api/patterns/insights/${analysisType}?${qs.toString()}`)
      .then((r) => setInsight(r.data))
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }

  return (
    <div className="rounded-md border-l-[3px] border-l-[#005BB3] dark:border-l-[#3b82f6] border border-[#E5E7EB] dark:border-[#1e2536] bg-[#F8F9FA] dark:bg-[#0f1219] px-5 py-4">
      <div className="flex items-center justify-between mb-2">
        <h3 className="text-[12px] uppercase tracking-[1px] font-medium text-[#005BB3] dark:text-[#3b82f6]" style={{ fontFamily: 'var(--font-sans)' }}>AI Insights</h3>
        {insight && !loading && (
          <button onClick={() => fetchInsight(true)} className="text-[12px] text-[#005BB3] dark:text-[#3b82f6] hover:text-[#004494] transition-colors duration-150" style={{ fontFamily: 'var(--font-sans)' }}>Regenerate</button>
        )}
      </div>

      {!insight && !loading && !error && (
        <>
          <p className="text-[#6B7280] text-[14px] mb-3" style={{ fontFamily: 'var(--font-sans)' }}>Get AI-powered analysis of these patterns and trends.</p>
          <button onClick={() => fetchInsight(false)} className="px-3 py-1.5 rounded-md bg-[#005BB3] hover:bg-[#004494] text-white text-[14px] font-medium transition-colors duration-150" style={{ fontFamily: 'var(--font-sans)' }}>Generate Insights</button>
        </>
      )}

      {loading && (
        <div className="flex items-center gap-2 py-3">
          <svg className="animate-spin h-3.5 w-3.5 text-[#005BB3]" viewBox="0 0 24 24" fill="none">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
          </svg>
          <span className="text-[#6B7280] text-[14px]" style={{ fontFamily: 'var(--font-sans)' }}>Generating...</span>
        </div>
      )}

      {error && (
        <div className="rounded bg-[rgba(239,68,68,0.06)] dark:bg-[rgba(239,68,68,0.08)] px-3 py-2 mt-1">
          <p className="text-[#DC2626] text-[13px]">Failed to load.</p>
          <button onClick={() => fetchInsight(false)} className="text-[12px] text-[#DC2626] underline mt-1">Retry</button>
        </div>
      )}

      {insight && !loading && (
        <div>
          {(insight.content || '').split('\n\n').map((para, i) => (
            <p key={i} className="text-[#1F2937] dark:text-[#8892a8] text-[14px] leading-[1.7] mb-2" style={{ fontFamily: 'var(--font-sans)' }}>{renderMarkdown(para)}</p>
          ))}
          <div className="flex items-center gap-2 mt-3 pt-2 border-t border-[#E5E7EB] dark:border-[#1e2536]">
            {insight.cached && <span className="text-[11px] uppercase tracking-[0.5px] font-semibold text-[#9CA3AF] px-1.5 py-0.5 rounded bg-[#F8F9FA] dark:bg-[#1a2030]">Cached</span>}
            <span className="text-[12px] text-[#6B7280]" style={{ fontFamily: 'var(--font-mono)' }}>{new Date(insight.created_at).toLocaleString()}</span>
          </div>
        </div>
      )}
    </div>
  );
}
